import * as React from "react";
import styled from "styled-components";
/* React components imports */
import {
    CTA,
    Card,
    Bottom,
    Cover,
    SubTitle,
    Information,
    Title,
    RetailerLogoWrapper,
} from "@tiendeo/react-components/dist/organisms/Cards/Card/Card.style";
import CardImage from "@tiendeo/react-components/dist/organisms/Cards/Card/CardImage";
import { Details } from "@tiendeo/react-components/dist/organisms/Cards/Card/Card.style";
import { SavedPage } from "types/SavedPage";
import CrossIcon from "@tiendeo/react-components/dist/atoms/Icons/Cross";
import ArrowRight from "@tiendeo/react-components/dist/atoms/Icons/ArrowRight";
import useTranslation from "translations/useTranslation";

interface IProps {
    savedPage: SavedPage;
    handleDeleteSavedPage: () => void;
    position: number;
}

const PageCard = styled(Card as any)`
    position: relative;
    text-decoration: none!important;
    @media (min-width: ${(props) => props.theme.layout.breakpoints.xs}) {
        max-width 165px;
        height: 350px;
    }  
`;
const CloseIconSection = styled.div`
    position: absolute;
    background-color: ${(props) => props.theme.colors.primary.primary700};
    top: 4px;
    right: 4px;
    height: 22px;
    width: 22px;
    z-index: 5;
    border-radius: 50%;
    z-index: 3;
    svg {
        fill: ${(props) => props.theme.colors.neutral.white};
    }
`;

const BottomSavedPage = styled(Bottom as any)`
    align-items: flex-start;
`;

const SavedPageCTA = styled(CTA as any)`
    display: flex;
    margin: 0;
    width: 100%;
    white-space: nowrap;
    justify-content: flex-end;

    svg {
        height: 35px;
        fill: ${(props) => props.theme.colors.primary.primary700};
    }
`;

function SavedPageCard({ savedPage, handleDeleteSavedPage, position }: IProps) {
    const t = useTranslation();
    const ctaText = t("OPEN_CATALOGUE");

    return (
        <PageCard
            as={"a"}
            href={savedPage.url}
            target="_blank"
            rel="nofollow"
            className="catalogo js-print-item"
            data-position={position}
            data-id={savedPage.id}
            data-brand={savedPage.retailer.name}
            data-category={savedPage.category.name}
            data-modelname={savedPage.modelName}
        >
            <CloseIconSection
                onClick={(e) => {
                    e.preventDefault();
                    handleDeleteSavedPage();
                }}
            >
                <CrossIcon />
            </CloseIconSection>
            <Cover>
                <CardImage src={savedPage.img} alt="" lazyload={false} blur />
                {savedPage.retailer?.logo2 && (
                    <RetailerLogoWrapper>
                        <CardImage src={savedPage.retailer.logo2} alt="" lazyload={false} />
                    </RetailerLogoWrapper>
                )}
            </Cover>
            <Information>
                <Details>
                    <SubTitle>{savedPage.retailer.name}</SubTitle>
                    <Title as={"h3"}>{savedPage.title}</Title>
                </Details>
                <BottomSavedPage>
                    <SavedPageCTA>
                        <div>{ctaText}</div>
                        <ArrowRight />
                    </SavedPageCTA>
                </BottomSavedPage>
            </Information>
        </PageCard>
    );
}

export default SavedPageCard;
